import { render, staticRenderFns } from "./ForwardFinishList.vue?vue&type=template&id=3af4f8da&scoped=true"
import script from "./ForwardFinishList.vue?vue&type=script&lang=js"
export * from "./ForwardFinishList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4f8da",
  null
  
)

export default component.exports